import React from 'react';

import { AutoSuggestControl } from 'app/components/Controls';
import { StreetNameControlProps } from './StreetNameControl.interfaces';
import { formatValue, useStreetNameControl } from './useStreetNameControl';
import { useStyles } from './StreetNameControl.styles';

export default function StreetNameControl(props: StreetNameControlProps) {
  const { handleChange, handleFocus, handleBlur } = useStreetNameControl(props);
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <AutoSuggestControl
        {...props}
        handleChange={handleChange}
        handleFocus={handleFocus}
        handleBlur={handleBlur}
        formatValue={formatValue}
        autoComplete="off"
        openOnFocus
        noLimit
      />
    </div>
  );
}
